import { render, staticRenderFns } from "./totalRecord.vue?vue&type=template&id=eba4ef46&scoped=true&"
import script from "./totalRecord.vue?vue&type=script&lang=js&"
export * from "./totalRecord.vue?vue&type=script&lang=js&"
import style0 from "./totalRecord.vue?vue&type=style&index=0&id=eba4ef46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eba4ef46",
  null
  
)

export default component.exports